const API_KEY = "70ee022622d62c8aef7c9ed9d4172d5b";
const BASE_URL = "https://api.themoviedb.org/3/";

const api = { API_KEY, BASE_URL };
export default api;
